<template lang="html">
  <boxwrap class="admin-list--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select2
          v-if="$route.params.type === 'users'"
          class="toolbar-nav"
          v-model="selectedList"
        >
          <option2
            v-for="(statusItem, statusKey) of statusListUser"
            :key="statusKey"
            :value="statusItem.value"
            :name="statusItem.display"
            :selected="selectedList === statusItem.value"
          >
            {{ statusItem.display }}
          </option2>
        </select2>

        <select2
          v-if="$route.params.type === 'admin'"
          class="toolbar-nav"
          v-model="selectedList"
        >
          <option2
            v-for="(statusItem, statusKey) of statusListAccessLogs"
            :key="statusKey"
            :value="statusItem.value"
            :name="statusItem.display"
            :selected="selectedList === statusItem.value"
          >
            {{ statusItem.display }}
          </option2>
        </select2>

        <search
          v-if="['setting'].includes($route.params.type)"
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBySetting"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        />

        <search
          v-if="['users'].includes($route.params.type)"
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterByUsers"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        />

        <search
          v-if="['games'].includes($route.params.type)"
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterByGames"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        />

        <search
          v-if="['rolling'].includes($route.params.type)"
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterByUserRolling"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        />

        <search
          v-if="['admin'].includes($route.params.type)"
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="[]"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        />

        <div class="toolbar-rightbtns">
          <!-- button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button -->
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="{ 'data-loading': showDataLoading }"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty || !logsList.list.length"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty || !logsList.list.length"
      />

      <tbl :scrollable="true">
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                <!-- no -->
                번호
              </tbl-td>

              <tbl-td
                v-if="checkCol('created_at', tblSetting)"
                @click.native="sort('creates_at')"
                name="created-at"
              >
                <!-- created -->
                생성일
              </tbl-td>

              <tbl-td
                name="admin-login-id"
                v-if="checkCol('login_id', tblSetting)"
                @click.native="sort(['rolling'].includes($route.params.type) ? 'admin.login_id' : 'login_id')"
              >
                <!-- login id -->
                관리자 아이디
              </tbl-td>

              <tbl-td
                name="admin-login-name"
                v-if="checkCol('login_name', tblSetting)"
                @click.native="sort(['rolling'].includes($route.params.type) ? 'admin.login_name' : 'login_name')"
              >
                <!-- login name -->
                관리자 명
              </tbl-td>

              <tbl-td
                name="user-login-id"
                v-if="checkCol('user_id', tblSetting) && ['user', 'rolling'].includes($route.params.type)"
                @click.native="sort(['rolling'].includes($route.params.type) ? 'user.login_id' : 'user_id')"
              >
                <!-- user id -->
                유저 아이디
              </tbl-td>

              <tbl-td
                name="user-login-name"
                v-if="checkCol('user_name', tblSetting) && ['user', 'rolling'].includes($route.params.type)"
                @click.native="sort(['rolling'].includes($route.params.type) ? 'user.login_name' : 'user_name')"
              >
                <!-- user name -->
                유저 닉네임
              </tbl-td>

              <tbl-td
                name="game-table"
                v-if="checkCol('login_name', tblSetting) && ['games'].includes($route.params.type)"
                @click.native="sort('game_table_id')"
              >
                <!-- game table -->
                게임구분
              </tbl-td>

              <tbl-td
                name="origin"
                v-if="checkCol('origin', tblSetting) && ['setting', 'users'].includes($route.params.type)"
                @click.native="sort('origin')"
              >
                <!-- origin -->
                변경적용
              </tbl-td>

              <tbl-td
                name="memo"
                v-if="checkCol('login_name', tblSetting) && $route.params.type !== 'admin'"
                @click.native="sort('memo')"
              >
                <!-- memo -->
                메모
              </tbl-td>

              <!-- <tbl-td
                v-if="checkCol('pages', tblSetting) && $route.params.type === 'users'"
                @click.native="sort('pages')"
                name="pages"
              >
                page | en
                위치 | kr
              </tbl-td> -->

              <tbl-td
                v-if="checkCol('origin_id', tblSetting) && ['games'].includes($route.params.type)"
                @click.native="sort('origin_id')"
                name="origin-id"
              >
                <!-- origin id -->
                구분 ID
              </tbl-td>

              <tbl-td
                name="ip"
                v-if="checkCol('ip', tblSetting)"
                @click.native="sort('ip')"
              >
                <!-- ip -->
                접속 ip
              </tbl-td>

              <tbl-td
                name="domain"
                v-if="checkCol('domain', tblSetting)"
                @click.native="sort('domain')"
              >
                <!-- domian -->
                접속 URL
              </tbl-td>

              <tbl-td
                name="actions"
                v-if="checkCol('action', tblSetting)"
                @click.native="sort('action')"
              >
                <!-- action -->
                구분
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(logItem, logKey) in logsList.list"
              :key="logKey"
            >
              <tbl-td name="no">
                {{ logItem.rowNumber }}
              </tbl-td>

              <tbl-td name="created-at">
                {{ dateFormatter(logItem.created_at) }}
              </tbl-td>

              <tbl-td name="login-id">
                {{ logItem.admin.login_id || '-' }}
              </tbl-td>

              <tbl-td name="login-name">
                {{ logItem.admin.login_name || '-' }}
              </tbl-td>

              <tbl-td
                v-if="['user', 'rolling'].includes($route.params.type)"
                name="login-name"
              >
                <span v-if="['leagues', 'games type', 'teams', 'odds maker setup', 'odds setting', 'display setting'].includes(logItem.origin)">
                  -
                </span>

                <span v-else>
                  {{ logItem.user.login_id || '-' }}
                </span>
              </tbl-td>

              <tbl-td
                v-if="['user', 'rolling'].includes($route.params.type)"
                name="login-name"
              >
                <span v-if="['leagues', 'games type', 'teams', 'odds maker setup', 'odds setting', 'display setting'].includes(logItem.origin)">
                  -
                </span>

                <span v-else>
                  {{ logItem.user.login_name || '-' }}
                </span>
              </tbl-td>

              <tbl-td
                v-if="['games'].includes($route.params.type)"
                name="game-table"
              >
                {{ logItem.table_name || '-' }}
              </tbl-td>

              <tbl-td
                v-if="['users', 'setting'].includes($route.params.type)"
                name="origin"
              >
                {{ _get(origins, logItem.origin, logItem.origin || '-') }}
              </tbl-td>

              <tbl-td
                v-if="$route.params.type !== 'admin'"
                name="memo"
              >
                <span v-if="['rolling'].includes($route.params.type)">
                  {{ logItem.type }}:[
                    sports: {{ logItem.memo.sports ? logItem.memo.sports.amount : 0 }} - {{ logItem.memo.sports ? _round(logItem.memo.sports.rolling, 2) : 0 }}% /
                    inplay: {{ logItem.memo.inplay ? logItem.memo.inplay.amount : 0 }} - {{ logItem.memo.inplay ? _round(logItem.memo.inplay.rolling, 2) : 0 }}% /
                    casino: {{ logItem.memo.casino ? logItem.memo.casino.amount : 0 }} - {{ logItem.memo.casino ? _round(logItem.memo.casino.rolling, 2) : 0 }}% /
                    token: {{ logItem.memo.token ? logItem.memo.token.amount : 0 }} - {{ logItem.memo.token ? _round(logItem.memo.token.rolling, 2) : 0 }}% /
                    casino: {{ logItem.memo.casino ? logItem.memo.casino.amount : 0 }} - {{ logItem.memo.casino ? _round(logItem.memo.casino.rolling, 2) : 0 }}% /
                    bet365: {{ logItem.memo.bet365 ? logItem.memo.bet365.amount : 0}} - {{ logItem.memo.bet365 ? _round(logItem.memo.bet365.rolling, 2) : 0 }}%
                  ]
                </span>

                <span v-else>
                  {{ logItem.memo }}
                </span>
              </tbl-td>

              <!-- <tbl-td
                v-if="$route.params.type === 'users'"
                name="pages"
              >
                {{ logItem.pages || '-' }}
              </tbl-td> -->

              <tbl-td
                v-if="['games'].includes($route.params.type)"
                name="origin-id"
              >
                {{ logItem.origin_id || '-' }}
              </tbl-td>

              <tbl-td name="ip">
                {{ logItem.ip }}
              </tbl-td>

              <tbl-td name="domain">
                {{ logItem.domain }}
              </tbl-td>

              <tbl-td name="actions">
                {{ _get(actions, logItem.action, logItem.action || '-') }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="logsList.count.total"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'

// = libs
import moment from 'moment'
import _round from 'lodash/round'
import _get from 'lodash/get'

// = components
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import Checkbox from '@/components/base/Checkbox'
import Modal from '@/components/base/Modal'
import '@/components/base/select/Select'

// = mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'

export default {
  name: 'admin-logs',

  components: {
    Pagination,
    Modal,
    Search,
    Checkbox,
    CheckDataList
  },

  mixins: [
    getListStatus,
    swal
  ],

  data () {
    return {
      isEmpty: false,
      isDataLoading: true,
      showDataLoading: false,
      showCreate: false,
      showModify: false,

      filterByUsers: [
        {
          value: 'login_id',
          display: '아이디'
        },
        {
          value: 'login_name',
          display: '닉네임'
        },
        {
          value: 'ip',
          display: 'ip'
        },
        {
          value: 'origin',
          display: '원본'
        },
        {
          value: 'domain',
          display: '도메인'
        }
      ],

      filterBySetting: [
        {
          value: 'login_id',
          display: '아이디'
        },
        {
          value: 'login_name',
          display: '닉네임'
        },
        {
          value: 'ip',
          display: 'ip'
        },
        {
          value: 'memo',
          display: '메모'
        },
        {
          value: 'domain',
          display: '도메인'
        }
      ],

      filterByGames: [
        {
          value: 'login_id',
          display: '아이디'
        },
        {
          value: 'login_name',
          display: '닉네임'
        },
        {
          value: 'game_name',
          display: '게임명'
        },
        {
          value: 'memo',
          display: '메모'
        },
        {
          value: 'origin_id',
          display: '적용ID'
        }
      ],

      filterByUserRolling: [
        {
          value: 'user.login_id',
          display: '유저 아이디'
        },
        {
          value: 'admin.login_id',
          display: '관리자 아이디'
        },
        {
          value: 'ip',
          display: 'ip'
        }
      ],

      dateBy: [
        {
          value: 'creates_at',
          display: '생성일자'
        }
      ],

      statusListUser: [
        {
          value: 'all',
          display: '전체'
        },
        {
          value: 'insert',
          display: '추가'
        },
        {
          value: 'deleted',
          display: '삭제'
        },
        {
          value: 'updated',
          display: '수정'
        }
      ],

      statusListAccessLogs: [
        {
          value: 'all',
          display: '전체'
        },
        {
          value: 'login',
          display: '로그인'
        },
        {
          value: 'logout',
          display: '로그아웃'
        }
      ],

      tblSetting: 'adminlogs',

      allCols: [
        {
          display: 'no',
          value: 'no'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'pages',
          value: 'pages'
        },
        {
          display: 'origin id',
          value: 'origin_id'
        },
        {
          display: 'origin',
          value: 'origin'
        },
        {
          display: 'ip',
          value: 'ip'
        },
        {
          display: 'domain',
          value: 'domain'
        }
      ]
    }
  },

  computed: {
    ...mapState('admin-logs', ['log', 'count', 'logsList']),

    checkPermission () {
      const permission = JSON.parse(window.localStorage.permission)
      const dbKey = this.$route.meta.dbKey
      let obj = ''

      for (const key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      console.log('ey')

      return obj === 'rw' ? 1 : ''
    },

    actions () {
      return {
        restore: '복원',
        deleted: '삭제',
        banned: '중지',
        modify: '수정',
        updated: '수정',
        created: '생성',
        create: '생성',
        login: '로그인',
        logout: '로그아웃',
        void: '적특',
        rollback: '복원',
        waiting: '대기중',
        active: '상태변경 사용',
        inactive: '상태변경 중지',
        result: '결과',
        insert: '추가'
      }
    },

    origins () {
      return {
        teams: '팀명설정',
        'odds setting': '배당설정',
        'odds maker setup': '제공사설정',
        leagues: '리그설정',
        'games type': '게임타입설정',
        games: '게임설정',
        'display setting': '표시설정',
        countries: '국가설정',
        admin: '관리자설정',
        users: '유저설정',
        points: '포인트',
        language: '기본언어',
        freeboard: '자유 게시판',
        helpdesk: '고객센터',
        'deposit account': '입금은행관리',
        cashin: '입/출/포인트 안내문',
        'session duration': '세션관리',
        'bank account': '입금은행 관리',
        sound: '알람소리',
        popups: '팝업관리',
        ticker: '흐름공지',
        domain: '도메인',
        'events page': '이벤트 페이지',
        'home page': '메인 페이지',
        navigation: '메인메뉴',
        'color setting': '회원성향'
      }
    }
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search(this.generate($router.query))
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/`)
    }

    this.query = this.generate(this.query)
    this.search()
  },

  methods: {
    _round,
    _get,

    ...mapActions('admin-logs', {
      get: 'fetch',
      getLogs: 'getLogs'
    }),

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async sort (arg) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = arg
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.status = this.$route.params.status
      this.query = query || this.query
      const type = this.$route.params.type

      const params = {
        ...this.query,
        status: this.status,
        type
      }

      // == flags reset
      this.isEmpty = false

      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getLogs(params)

      this.isDataLoading = false
      this.showDataLoading = false

      if (!this.logsList.list && !this.logsList.list.length) {
        this.isEmpty = true
      }
    },

    dateFormatter (value) {
      return moment(value).utc().format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
